import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import DataTable from "react-data-table-component";
import { useSelector, useDispatch } from "react-redux";
import { getMaterialList } from "../../../../redux/feature/customer_app/customerV1Slice";
// import { SearchField } from "../../../../Components/formElements/SearchField";

const EstimateMaterialSelectionModal = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const materialData = useSelector(
    (state) => state?.customerV1?.material?.data,
  );

  const [disabled, setDisabled] = useState(true);
  const [data, setData] = useState([]);
  // console.log(">>data",data)
  const [getSelectedData, setSelectedData] = useState([]);
  // const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [searchCode, setSearchCode] = useState("");

  // 🔹 Filter States
  const [filterType, setFilterType] = useState("");
  const [selectedValue, setSelectedValue] = useState("");

  // 🔹 Filter Type Options
  // const filterTypeOptions = [
  //   { label: "Building Type", value: "buildingType" },
  //   { label: "Component Key", value: "componentKey" },
  //   { label: "Material Group", value: "materialGroupCode" },
  // ];

  const filterTypeOptions = [
    { label: "Material Group", value: "materialGroup" },
    { label: "Material Group Code", value: "materialGroupCode" },
  ];

  // 🔹 Dropdown Options
  // const buildingTypeOptions = ["CS", "PEB", "RC"];

  // const componentKeyOptions = [
  //   "BU", "PL", "COL", "BR", "RA", "CL", "RF", "WL", "FS",
  //   "PB", "RO", "FP", "LP", "ST", "HR", "CF", "CR",
  //   "ME", "FA", "IN", "EN", "RSW", "LEW", "R1", "R2",
  //   "ROD", "CAN", "LT", "MS"
  // ];
  const materialGroupCodeOptions = [
    "BUW",
    "BUF",
    "CONWT",
    "BUWT",
    "HBZ",
    "HBNZ",
    "HBC",
    "INC",
    "INZ",
    "HBEA",
    "APSHS",
    "APRHS",
    "APCHS",
    "SRD",
    "ISEA",
    "ISUA",
    "ISJC",
    "ISJB",
    "ROOFBG",
    "ROOFPPG",
    "CLADBG",
    "CLADPPG",
    "TR",
    "GUTTER",
    "VGUTTER",
    "GUTTEREC",
    "GUTTERSTRP",
    "RDFLASH",
    "BGCAP",
    "GBANGLE",
    "EDANGLE",
    "DRFLASH",
    "ICORFLASH",
    "OCORFLASH",
    "APRON",
    "CANOPYBOTTOMFLASH",
    "DOWNSPOUT",
    "DOWNSPOUTSTRP",
    "CGLADDER",
    "STAIRCASE",
    "AB",
    "MSB",
    "HTB",
  ];

  // const materialGroupOptions = ["HB", "MB", "FB"];
  const materialGroupOptions = [
    "BUILT UP PLATES",
    "COLDROLLED",
    "HR",
    "HR - INDIAN STANDARD ANGLES",
    "HR - INDIAN STANDARD CHANNELS",
    "HR - INDIAN STANDARD BEAMS",
    "SHEETING",
    "FLASHINGS",
    "ANCHOR BOLTS",
    "MS HT BOLTS",
  ];

  // 🔹 Initial Load (Get All)
  useEffect(() => {
    const obj = {
      queryName: "Get_MATERIAL_LIST",
      page: 1,
      per_page: 9999,
    };
    dispatch(getMaterialList(obj));
  }, [dispatch]);

  // 🔹 Map Data for Table
  useEffect(() => {
    if (materialData && Array.isArray(materialData)) {
      const mappedData = materialData.map((item) => ({
        code: item.materialCode || "--",
        description: item.materialDescription || "--",
        avg: item.avg !== 0 ? item.avg : 1,
        quantity: item.quntity || 0,
        pieceMeasure: item.pieceMeasure || 0,
        unit: item.unit || "--",
        unitWeight: item.unitWeight || 0,
        unitPrice: item.unitPrice || 0,
        pieceWeight: item.weightPice || 0,
        totalWeight: item.weightTotal || 0,
        price: item.bookPrice || 0,
        totalPrice: item.bookTotalPrice || 0,
        unitWeightModifier: item.unitWeightModifier || 1,
        unitPriceModifier: item.unitPriceModifier || 1,
        remarks: item.remarks || "--",
        materialGroup: item.materialGroup || "--",
        materialGroupCode: item.materialGroupCode || "--",
        materialImage: item.materialImage || "",
        surfacePaintArea: item.surfacePaintArea || "",
      }));
      setData(mappedData);
    } else {
      setData([]);
    }
  }, [materialData]);

  // 🔹 Table Row Selection
  const handleChangeCat = ({ selectedRows }) => {
    setSelectedData(selectedRows);
    setDisabled(selectedRows.length === 0);
  };

  // 🔹 Submit Selected
  const handleSubmit = () => {
    props.onselectedcatdata(getSelectedData);
    props.onHide();
  };

  const handleSearchByCode = async () => {
    if (!searchCode.trim()) {
      alert("Please enter a material code");
      return;
    }

    const payload = {
      queryName: "Get_Material_BY_TYPE",
      rowFilter: {
        $and: [
          // {
          //   materialCode: { $in: [searchCode.trim()] },
          // },

          {
            materialCode: {
              $regex: searchCode.trim(),
              $options: "i",
            },
          },
        ],
      },
    };

    dispatch(getMaterialList(payload));
  };

  // 🔹 Handle Key Press for Search
  const handleSearchKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearchByCode();
    }
  };

  // 🔹 Handle Filter (Dynamic Payload)
  const handleFilter = async () => {
    if (!filterType || !selectedValue) {
      alert("Please select a filter type and value");
      return;
    }

    const payload = {
      queryName: "Get_Material_BY_TYPE",
      rowFilter: {
        $and: [
          {
            [filterType]: { $in: [selectedValue] },
          },
        ],
      },
    };

    dispatch(getMaterialList(payload));
  };

  // 🔹 Search API
  // const handleSearchFuncApi = async () => {
  //   let obj = {
  //     queryName: "Get_Material_BY_TYPE",
  //     searchTerm: getCommonSearchTxt,
  //   };
  //   dispatch(getMaterialList(obj));
  // };

  // 🔹 Table Columns
  const columns = [
    {
      name: "Code & Description",
      sortable: true,
      grow: 2,
      cell: (row) => (
        <div>
          <div className="fw-bold">{row.code}</div>
          <div>{row.description}</div>
        </div>
      ),
    },
    { name: "UOM", selector: (row) => row.unit, sortable: true },
    {
      name: "Unit Weight",
      selector: (row) =>
        typeof row.unitWeight === "number"
          ? row.unitWeight.toFixed(4)
          : row.unitWeight,
      sortable: true,
    },
    { name: "Unit Price", selector: (row) => row.unitPrice, sortable: true },
    // { name: "Avg", selector: (row) => row.avg, sortable: true },
    {
      name: "Group",
      selector: (row) => row.materialGroup,
      cell: (row) => (
        <div>
          <div className="fw-bold">{row.materialGroup}</div>
          <div>{row.materialGroupCode}</div>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Surface/Paint",
      selector: (row) => row.surfacePaintArea,
      sortable: true,
    },
    // { name: "Remarks", selector: (row) => row.remarks, sortable: true },
  ];

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      dialogClassName="modal-90w"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>Material Selection</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row className="mb-3 align-items-end">
         
        </Row>
        {/* 🔹 Filter Section */}
        <Row className="mb-3 align-items-end">
          {/* Filter Type */}
          <Col md={3} className="commTopButtonRightLeftPadding">
            <label>Filter Type</label>
            <select
              className="form-select"
              value={filterType}
              onChange={(e) => {
                setFilterType(e.target.value);
                setSelectedValue("");
              }}
            >
              <option value="">-- Select Filter Type --</option>
              {filterTypeOptions.map((f) => (
                <option key={f.value} value={f.value}>
                  {f.label}
                </option>
              ))}
            </select>
          </Col>

          {/* Dynamic Dropdown */}
          {filterType && (
            <Col md={3} className="commTopButtonRightLeftPadding">
              <label>
                {filterTypeOptions.find((f) => f.value === filterType)?.label}
              </label>
              <select
                className="form-select"
                value={selectedValue}
                onChange={(e) => setSelectedValue(e.target.value)}
              >
                <option value="">-- Select --</option>
                
                {filterType === "materialGroup" &&
                  materialGroupOptions.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}

                {filterType === "materialGroupCode" &&
                  materialGroupCodeOptions.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
              </select>
            </Col>
            
          )}
             <Col md={3} className="commTopButtonRightLeftPadding">
            <label>Search by Material Code</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter material code..."
              value={searchCode}
              onChange={(e) => setSearchCode(e.target.value)}
              onKeyPress={handleSearchKeyPress}
            />
          </Col>

          {/* Filter Button */}
          <Col md={2} className="commTopButtonRightLeftPadding">
            <button
              type="button"
              className="btn btn-primary w-100"
              onClick={handleFilter}
            >
              Filter
            </button>
          </Col>

          
        </Row>

        {/* 🔹 Data Table */}
        <DataTable
          columns={columns}
          data={data}
          selectableRows
          onSelectedRowsChange={handleChangeCat}
          pagination
          highlightOnHover
          striped
          dense
          responsive
        />

        {/* 🔹 Action Buttons */}
        <Row className="justify-end mt-4">
          <Col xs={6} md={2}>
            <button
              type="button"
              onClick={() => props.onHide()}
              className="btn btn-danger w-100"
            >
              Cancel
            </button>
          </Col>
          <Col xs={6} md={2}>
            <button
              type="button"
              onClick={handleSubmit}
              className="btn btn-primary w-100 mx-1"
              disabled={disabled}
            >
              Select
            </button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
});

export default EstimateMaterialSelectionModal;
